import { Button } from 'react-aria-components'
import Modal from '@/components/modal/Modal'

type FilterModalProps = {
  children: React.ReactNode
  footerComponent?: React.ReactNode | null
  title?: string
}

export default function FilterModal({
  children,
  footerComponent,
  title = 'Filters',
}: FilterModalProps): JSX.Element {
  const Trigger = () => (
    <div className="xs:w-full">
      <Button className="btn btn--outline btn--default btn--small min-w-[118px] m:py-16 xs:block xs:min-w-full">
        Filters
      </Button>
    </div>
  )

  return (
    <Modal title={title} trigger={<Trigger />} footerComponent={footerComponent}>
      {children}
    </Modal>
  )
}
